module.exports = __webpack_public_path__ + "img/elevate-care-bg.0a1e0ab1.png";